// TMOS Public API Service
// Date: January 27, 2025
// Purpose: API service for public website endpoints (no authentication required)

import axios from 'axios';

// VITE_API_URL in production (e.g. GitHub Actions or AWS); dev uses relative so proxy works.
const API_BASE_URL = (import.meta as any).env?.VITE_API_URL
  ? (import.meta as any).env.VITE_API_URL.replace(/\/$/, '') + '/api'
  : import.meta.env.DEV ? '/api' : 'http://localhost:3000/api';

/**
 * Public API instance - no authentication required
 * Used for public website content that doesn't require login
 */
const publicApi = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
    timeout: 30000, // 30 seconds timeout
});

// No authentication interceptors needed for public API

export default publicApi;

